import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './FIIInvestment.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import OtherMarketOption from "../../OtherMarketOption/OtherMarketOption";
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../../Activity_Track/CallTrackApi";


function FIIInvestment() {
    const [data, setData] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);

        const getUrl = BaseURL + "OtherMarkets";


        fetch(`${getUrl}/FII/20`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                // console.log(getData, "getData")

                setloadingshow(false);
            })
            .catch((error) => {
            });


    }, []);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    
    CallTrackApi("FII Investment",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>FII Investment</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='FII-loser-sc'>
                            <div className='FII-header'>
                                <h2><span>FII Investment</span></h2>
                            </div>
                            <OtherMarketOption optionOtherMarket="FII Investment" />
                            <hr className="FIIhr"></hr>
                            <div className='FII-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>



                                            <th className='text-left' >As On Date</th>
                                            <th className='FIItxt' >Equity/Debt</th>



                                            <th className='text-right'>Gross Purchase(&#8377;)</th>
                                            <th className='text-right'>Gross Sale(&#8377;)</th>
                                            <th className='text-right'> Net Purchase(&#8377;)</th>
                                            <th className='text-right'>Cumulative Investment US $m at<br></br> monthlyexchange ratio</th>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(

                                            ({ DATE, EQ_G_PURCH, EQ_G_SALES, EQ_N_INVES, EQ_CNIM_EX, DB_G_PURCH, DB_G_SALES, DB_N_INVES, DB_CNIM_EX }) => (
                                                <>


                                                    <tr>
                                                        <td className="text-left"> {(DATE != null) ? DATE.split('T')[0] : 0}</td>
                                                        <td className="text-left"> Equity</td>
                                                        <td className="text-right">{EQ_G_PURCH}</td>
                                                        <td className="text-right">{EQ_G_SALES}</td>
                                                        <td className="text-right">{EQ_N_INVES}</td>
                                                        <td className="text-right">{EQ_CNIM_EX}</td>
                                                    </tr>


                                                    <tr>
                                                        <td></td>
                                                        <td className="text-left">Debt</td>
                                                        <td className="text-right">{DB_G_PURCH}</td>
                                                        <td className="text-right">{DB_G_SALES}</td>
                                                        <td className="text-right">{DB_N_INVES}</td>
                                                        <td className="text-right">{DB_CNIM_EX}</td>
                                                    </tr>

                                                </>

                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }


                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default FIIInvestment;